// extracted by mini-css-extract-plugin
export default {"container":"PropertyPageSlider_container__WrEHX","sliderItem":"PropertyPageSlider_sliderItem__1cFlA"};